import { render } from "./_organization.vue?vue&type=template&id=99e411e8&scoped=true"
import script from "./_organization.vue?vue&type=script&lang=js"
export * from "./_organization.vue?vue&type=script&lang=js"

import "./_organization.vue?vue&type=style&index=0&id=99e411e8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99e411e8"]])

export default __exports__